import { InjectionToken } from '@angular/core'

import { FeatureMap } from '../feature-flags/feature-flags.model'

export interface Environment {
  production: boolean
  name: string

  apiUrl: string
  socketUrl: string

  tenantId?: string
  logoUrl?: string

  serviceApiKey?: string

  features: FeatureMap
}

export const ENVIRONMENT = new InjectionToken<Environment>('Environment token')
